export default {
	mounted() {
		if (location.hash) {
			let privateModalName = location.hash.slice(1);
            switch(privateModalName) {
                case 'credit': privateModalName = 'private__services-card__crediting'; break;
                case 'invest': privateModalName = 'private__services-card__investments'; break;
                case 'deposit': privateModalName = 'private__services-card__deposit-rates'; break;
                case 'mortgage': privateModalName = 'private__services-card__mortgage-securities'; break;
                case 'service': privateModalName = 'private__services-card__additional-services'; break;
            }
            this.$modal.show(privateModalName)
		}
	}
}
